//-------------------------------------------------------------------------------------------------- Imports
import { Card, Col, Row } from "antd";
import { StyleSheet } from "../../../StyleSheet";
import { DownOutlined, RightOutlined, UpOutlined } from "@ant-design/icons";
import { ResponsePackageGroups } from "../../../types/common";
import _ from "lodash";
import Packages from "./Packages";
import { useNavigate } from "react-router-dom";
import MarkdownPreviewer from "../../../common/MarkdownPreviewer";

//-------------------------------------------------------------------------------------------------- Interface
interface ServicesCardProps {
    id: number,
    selection: number | undefined;
    service: ResponsePackageGroups;
    onClick: Function;
    // validateAllServices: (clientId: string) => Promise<void>;
};

//-------------------------------------------------------------------------------------------------- Component
const ServicesCard = (props: ServicesCardProps) => {
    const { id, selection, service, onClick } = props;
    const navigate = useNavigate();

    const navigateTo = () => {
        switch (service.route) {
            case "PortabilityHome":
                navigate("/portability");
                break;
            default:
                break;
        }
    };

    return (
        <Card
            key={id}
            style={styles.card}
            bodyStyle={{ padding: "0" }}
            onClick={() => (service.route) ? navigateTo() : undefined}
        >
            <Row gutter={[12, 12]}
                align={"middle"}
                justify={"space-around"}
                onClick={() => onClick && onClick()}
                style={styles.mainContainer}
            >
                <Col xs={24} md={10}>
                    <div style={styles.imageContainer}>
                        <img
                            style={styles.image}
                            src={service.logoImgUrl}
                            alt="Imágen de la promoción"
                        />
                    </div>
                </Col>
                <Col xs={24} md={12}>
                    <MarkdownPreviewer
                        h1Style={{
                            fontSize: 15,
                            color: "#000000",
                            fontWeight: 500
                        }}
                        h2Style={{
                            fontSize: 12,
                            color: "#707070",
                            fontWeight: 500
                        }}
                        h3Style={{
                            fontSize: 12,
                            color: "#000000",
                            margin: 0,
                            padding: 0,
                            fontWeight: 500
                        }}
                        h4Style={{
                            fontSize: 12,
                            color: "#000000",
                            margin: 0,
                            padding: 0,
                            fontWeight: 500
                        }}
                        textStyle={{
                            fontSize: 10,
                            color: "#000000",
                            margin: 0,
                            padding: 0,
                        }}
                        linkStyle={{
                            fontSize: 12,
                            color: "#000000",
                            textDecoration: "underline",
                        }}
                        mdSource={service.messageText ? service.messageText : ""}
                    />
                </Col>
                <Col xs={2}>
                    {
                        service.route && !_.isEmpty(service.route) ?
                            <RightOutlined style={styles.iconStyles} />
                            :
                            id === selection ?
                                <UpOutlined style={styles.iconStyles} />
                                :
                                <DownOutlined style={styles.iconStyles} />
                    }
                </Col>
            </Row>
            {
                id === selection && !service.route &&
                <Packages packages={service.packages} />
            }
        </Card>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    card: {
        margin: 10,
        display: "flex",
        flexDirection: "column",
        borderRadius: 25,
        boxShadow: "0px 0px 8px #00000029",
    },
    mainContainer: {
        padding: "0px 10px 0px 10px",
        cursor: "pointer",
    },
    imageContainer: {
        display: "flex",
        height: 75,
    },
    textContainer: {
        flex: 1,
        display: "flex",
    },
    image: {
        width: 120,
        objectFit: "contain",
    },
    iconContainer: {
        display: "flex",
    },
    iconStyles: {
        fontSize: 12,
        color: "#757982",
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export default ServicesCard;
